<template>
  <div class="idcard-passport-info-modal">
    <el-dialog
      :visible.sync="visible"
      size="small"
      :show-close="false"
      :close-on-click-modal="false">
      <!-- 头部 -->
      <div class="custom-header">
        {{typeInfo}}
        <!-- 关闭 -->
        <div class="el-dialog__headerbtn" @click="closeModal">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>

      <idcard-passport-info
        :type="type"
        :info="info"
        ref="infoDetail"
        :applicantId="applicantId"
        :orderId="orderId"
        :currentMaterial="currentMaterial"
        :readOnly="readOnly"
        :cancelText="cancelText"
        :showCancel="showCancel"
        :showSave="showSave"
        @closeModal="closeModal"
        @updateOrder="updateOrder"
        @successTips="successTips">
      </idcard-passport-info>
    </el-dialog>
  </div>
</template>

<script>

import IdcardPassportInfo from './idcard-passport-info';

export default {
  name: 'idcard-passport-info-modal',
  components: {
    IdcardPassportInfo,
  },
  props: {
    info: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    type: {
      type: String,
      required: true,
      default: '',
    },
    show: {
      type: Boolean,
      required: true,
      default: true,
    },
    orderId: {
      type: Number,
      required: true,
    },
    applicantId: {
      type: Number,
      required: true,
    },
    currentMaterial: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: '重新上传',
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    showSave: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    visible: {
      get() {
        // 这里是只有护照才需要去同步省份和保存所选的出生地点和签发地点
        if (this.show && this.type === 'passport' && !this.readOnly) {
          this.$nextTick(() => {
            this.$refs.infoDetail.saveOtherPlace();
          });
        }
        // 当弹窗出现时，立即去检查各个字段是否合法
        if (this.show && !this.readOnly) {
          this.$nextTick(() => {
            this.$refs.infoDetail.checkValid();
          });
        }
        return this.show;
      },
      set(newValue) {
        this.$emit('visibleSync', newValue);
      },
    },
    typeInfo() {
      if (this.type === 'passport') return '护照首页信息读取';
      else if (this.type === 'idcarda') return '身份证人像面信息读取';
      else if (this.type === 'idcardb') return '身份证国徽面信息读取';
    },
  },
  methods: {
    // 关闭对话框回调
    closeModal() {
      this.visible = false;
      this.$refs.infoDetail.resetScale();
    },
    updateOrder() {
      this.$emit('updateOrder');
    },
    successTips() {
      this.$emit('successTips');
    },
  },
};
</script>

<style lang="less">
@import "../../../../assets/less/variable";

.idcard-passport-info-modal {

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog--small{
    width: 860px;
    .custom-header{
      height: 50px;
      display: block;
      padding: 0 20px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-bottom: 1px solid #f0f0f0;
      font-size: 16px;
      color: #333333;
      .el-dialog__close {
        position: absolute;
        right: 20px;
        top: 16px;
        width: 19px;
        height: 19px;
        transform: rotateZ(45deg);
        cursor: pointer;

        &::before {
          content: "";
          display: block;
          width: 19px;
          position: absolute;
          top: 9px;
          left: 0;
          border-top: 1px solid #777;
        }

        &::after {
          content: "";
          display: block;
          height: 19px;
          position: absolute;
          top: 0;
          left: 9px;
          border-left: 1px solid #777;
        }

        &:hover {
          &::before,
          &::after {
            border-color: @main;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/modals/idcard-passport-info-modal/idcard-passport-info-modal.vue